export default __webpack_public_path__ + "static/media/welqome.ee039ad8.webp";